import React from "react";
import setWindowLocationHref from "~/common/navigation/setWindowLocationHref";
import { PricingProduct } from "~/ProductDetails/Pricing/PricingProduct";
import ValidationError from "./ValidationError";
import { getValidationError, groupingSelected } from "./validations";

interface Props {
  customizationUrl: string;
  product: PricingProduct;
  handleSetErrorMessage: (errorMessage: string) => void;
  handleAddToCartError: (validationError: ValidationError | undefined) => void;
}

const RequiredCustomizationButton = ({
  customizationUrl,
  product,
  handleSetErrorMessage,
  handleAddToCartError,
}: Props) => {
  const handleValidation = (event: React.SyntheticEvent) => {
    event.preventDefault();
    const validationError = getValidationError({
      product,
      quantity: 1,
      validationsToRun: [groupingSelected],
    });

    // eslint-disable-next-line no-extra-boolean-cast
    if (!!validationError?.message?.length) {
      handleSetErrorMessage(validationError.message);
      handleAddToCartError(validationError);
    } else {
      setWindowLocationHref(customizationUrl);
    }
  };

  return (
    <div className="add-to-cart">
      <div
        className="btn-container special-quantity"
        data-component="specialQuantity"
      >
        <a
          href={customizationUrl}
          data-testid="customization-url"
          onClick={handleValidation}
        >
          <button type="button" className="btn btn-large btn-icon--customize">
            <img
              className="btn-icon-wand"
              src="//cdnimg.webstaurantstore.com/uploads/blog/2019/3/wand-icon.png"
              alt="Wand Icon"
            />
            Customize &amp; Add to Cart
          </button>
        </a>
      </div>
    </div>
  );
};

export default RequiredCustomizationButton;
